// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-621214a1] .theme--dark.v-list-item--active:before,\n.theme--light.v-list-item--active[data-v-621214a1]:hover:before,\n.theme--light.v-list-item[data-v-621214a1]:focus:before {\n  opacity: 0;\n}\n[data-v-621214a1] .v-list-item--active.is-minimized {\n  background-color: white;\n}\n[data-v-621214a1] .v-list-item--active.is-minimized .v-list-item__icon {\n  color: #255cc2;\n}\n.account-layout__icon[data-v-621214a1] {\n  font-size: 20px !important;\n}", ""]);
// Exports
module.exports = exports;
